import DTO from './DTO';

class MaisEguDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'id',
        type: String,
        validators: {},
        labelKey: 'mais.egu.id',
      },
      {
        name: 'name',
        type: Number,
        validators: {},
        labelKey: 'mais.egu.name',
      },
      {
        name: 'description',
        type: String,
        validators: {},
        labelKey: 'mais.egu.description',
      },
      {
        name: 'procedure',
        type: String,
        validators: {},
        labelKey: 'mais.egu.procedure',
      },
      {
        name: 'cron',
        type: String,
        validators: {},
        labelKey: 'mais.egu.cron',
      },
      {
        name: 'status',
        type: String,
        validators: {},
        labelKey: 'mais.egu.status',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {};
  }
}

export default MaisEguDTO;
